import flowRuleApi from '@/api/config/flowRuleApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useSearchFlowRuleId(interfaceId: number, id: number) {
  return useQuery(
    [queryKeys.flowRule, id],
    async () => {
      const { data } = await flowRuleApi.getById(interfaceId, id)

      if (!data) return null

      return data
    },
    {
      enabled: !!id,
    },
  )
}

export default useSearchFlowRuleId
